import { Navigate, useParams } from "react-router-dom";

/** Legacy route — redirect into room-scoped host chat. */
function Whatsappchat() {
  const params = useParams();
  const roomUuid =
    params.room_uuid ||
    localStorage.getItem("room_uuid") ||
    window.location.pathname.split("/")[1] ||
    localStorage.getItem("room_uuid_before_redirect");

  if (roomUuid) {
    return <Navigate to={`/${roomUuid}/chat`} replace />;
  }

  return <Navigate to="/" replace />;
}

export default Whatsappchat;
